import * as types from '../mutation-types'
import conteststates from '../../api/contest/contest-states'

///INITIAL STATE
const state = {
    state: null,
    scenario: null,
    timer: null,
    elapsed: 0,
    checked: [],
    openAnswer: null,
    test: null,
    testsPassed: 0,
    questionsPassed: 0,
    question : null,
    report : null,
    exitResult : null,
    awaitNext : false,
    showPassed : true
}

///GETTERS
const getters = {
    currentState: state => state.state,
    isAwaitingNext: state => state.awaitNext,
    isContestAuthorized: state => state.state === null ? false : true,
    timer: state => state.timer,
    elapsedTime: state => state.elapsed,
    showExit: state => {
      if(state.state) {
          const order = state.state.order;
          if(order && (order === 2 || order === 3) && !state.isPsycho)
            return true;
      }
      return false;
    },
    showSkip: state => {
      if(state.state) {
        const order = state.state.order;
        if(order && order === 3 && !state.isPsycho)
          return true;
      }
      return false;
    },
    showNext: state => {
      if(state.state) {
        const order = state.state.order;
        if(order && order === 3 && state.isPsycho)
          return false;
      }
      return true;
    },
    showProgress: state => {
      if(state.state) {
          const order = state.state.order;
          if(order && (order === 2 || order === 3 || order === 4))
            return true;
      }
      return false;
    },
    nextLabel: state => {
      if(state.state) {
        const order = state.state.order;
        if(order && order === 6)
          return 'Выход';
      }
      return 'Вперед';
    },
    scenarioLabel: state => {
      return state.scenario ? state.scenario.label : '';
    },
    scenarioDescription: state => {
      return state.scenario ? state.scenario.description : '';
    },
    scenarioContinued: state => {
      //TODO remove hardcode
      return false;
    },
    scenarioUser: state => {
      return state.scenario ? state.scenario.userFullName : '';
    },
    scenarioUid: state => {
      return state.scenario ? state.scenario.uid : null;
    },
    scenarioTestsCount: state => {
      return state.scenario ? state.scenario.testCount : 0;
    },
    scenarioTestsPassedCount: state => {
      return state.testsPassed;
    },
    testLabel: state => {
      return state.test ? state.test.label : '';
    },
    testDescription: state => {
      return state.test ? state.test.description : '';
    },
    testTime: state => {
      return state.test ? state.test.timeInMinutes : 0;
    },
    testUid: state => {
      return state.test ? state.test.uid : null;
    },
    testQuestionsCount: state => {
      return state.test ? state.test.questionCount : 0;
    },
    testQuestionsPassedCount: state => {
      return state.questionsPassed;
    },
    questionNumber: state => {
      return state.question ? state.question.orderNumber : 0;
    },
    questionText: state => {
      return state.question ? state.question.text : '';
    },
    questionDescription: state => {
      return state.question ? state.question.explanation : '';
    },
    questionImage: state => {
      return state.question ? state.question.imageUrl : '';
    },
    questionUid: state => {
      return state.question ? state.question.uid : null;
    },
    answers: state => {
      if(state.question) {
        let a = state.question.answers;
        if(a && a.length)
          return a;
      }
      return [];
    },
    checkedAnswers: state => {
      return state.checked;
    },
    inputedAnswer: state => {
      return state.openAnswer;
    },
    isSimple: state => {
      if(state.question) {
        let type = state.question.questionType;
        if(type === 1 || type === 2 || type === 3)
          return true;
      }
      return false;
    },
    isMultiple: state => {
      if(state.question) {
        let type = state.question.questionType;
        if(type === 2)
          return true;
      }
      return false;
    },
    isOpen: state => {
      if(state.question) {
        let type = state.question.questionType;
        if(type === 3)
          return true;
      }
      return false;
    },
    isPsycho: state => {
      //TODO
      return false;
    },
    scenarioResults: state => {
      return state.report ? state.report.tests : [];
    },
    scenarioResultLabel: state => {
      return state.report ? state.report.label : '';
    },
    scenarioResultUser: state => {
      return state.report ? state.report.fullName : '';
    },
    scenarioResultTotal: state => {
      return state.report ? state.report.total : null;
    },
    scenarioDateFinished: state => {
      return state.report ? state.report.dateFinished : null;
    },
    scenarioTimeElapsed: state => {
      return state.report ? state.report.timeElapsedInSeconds : 0;
    },
    showPassed: state => {
      //TODO
      //return true;
      return state.showPassed;
    },
    isPassed: state => {
      return state.exitResult ? state.exitResult.isPassed : false;
    }
}

///ACTIONS
const actions = {
  nextState ({commit, state}, order) {
    //let currentState = initial ? null : state.state;
    //const newState = conteststates.getNextState(currentState);
    const newState = conteststates.getStateByOrder(order);
    commit(types.SET_STATE, { newState });
  },
  setStateByOrder({commit}, order) {
    const newState = conteststates.getStateByOrder(order);
    commit(types.SET_STATE, { newState });
  },
  setTimer({commit}, timer) {
    const newTimer = timer;
    commit(types.SET_TIMER, { newTimer });
  },
  timerTick({commit}) {
    commit(types.TICK);
  },
  singleAnswer({commit}, answer) {
    commit(types.SINGLE_ANSWER, { answer });
  },
  answer({commit}, answer) {
    commit(types.ANSWER, { answer });
  },
  resetAnswer({commit}) {
    commit(types.RESET_ANSWER);
  },
  inputAnswer({commit}, openAnswer) {
    commit(types.INPUT_ANSWER, { openAnswer });
  },
  initializeTest({commit}, test) {
    commit(types.INITIALIZE_TEST, { test });
  },
  initializeScenario({commit}, scenario) {
    commit(types.INITIALIZE_SCENARIO, { scenario });
  },
  initializeQuestion({commit}, question) {
    commit(types.INITIALIZE_QUESTION, { question });
  },
  passTest({commit}) {
    commit(types.PASS_TEST);
  },
  passQuestion({commit}) {
    commit(types.PASS_QUESTION);
  },
  processLoad({commit}, flag) {
    commit(types.AWAIT_NEXT, { flag });
  },
  initializeReport({commit}, report) {
    commit(types.INITIALIZE_REPORT, { report });
  },
  initializeExit({commit}, exit) {
    commit(types.INITIALIZE_EXIT, { exit });
  },
  processShowPassed({commit}, flag) {
    commit(types.SHOW_PASSED, { flag });
  }
}

///MUTATIONS
const mutations = {
  [types.SET_STATE] (state, { newState }) {
    //TODO evaluate if should be next
    state.state = newState;
    if(!newState) {
      state.timer = null;
      state.elapsed = 0;
      state.scenario = null;
      state.checked = [];
      state.openAnswer = null;
      state.test = null;
      state.testsPassed = 0;
      state.questionsPassed = 0;
      state.question = null;
      state.awaitNext = false;
      state.report = null;
      state.exitResult = null;
      state.showPassed = true;
    }
  },
  [types.SET_TIMER] (state, { newTimer }) {
    state.timer = newTimer;
  },
  [types.TICK] (state) {
    state.elapsed++;
  },
  [types.SINGLE_ANSWER] (state, { answer }) {
    state.checked = [];
    if(answer)
      state.checked.push(answer);
  },
  [types.ANSWER] (state, { answer }) {
    if(answer) {
      let index = state.checked.indexOf(answer);
      if (index > -1)
        state.checked.splice(index, 1);
      else
        state.checked.push(answer);
    }
  },
  [types.RESET_ANSWER] (state) {
    state.checked = [];
    state.openAnswer = null;
  },
  [types.INPUT_ANSWER] (state, { openAnswer }) {
    state.openAnswer = null;
    if(openAnswer)
      state.openAnswer = openAnswer;
  },
  [types.INITIALIZE_TEST] (state, { test }) {
    state.questionsPassed = 0;
    state.test = test;
  },
  [types.INITIALIZE_SCENARIO] (state, { scenario }) {
    if(!state.scenario && scenario) {
      state.testsPassed = 0;
      state.scenario = scenario;
    }
  },
  [types.INITIALIZE_QUESTION] (state, { question }) {
    state.question = question;
  },
  [types.PASS_TEST] (state) {
    state.testsPassed++;
  },
  [types.PASS_QUESTION] (state) {
    state.questionsPassed++;
  },
  [types.AWAIT_NEXT] (state, { flag }) {
    state.awaitNext = flag;
  },
  [types.INITIALIZE_REPORT] (state, { report }) {
    state.report = report;
  },
  [types.INITIALIZE_EXIT] (state, { exit }) {
    state.exitResult = exit;
  },
  [types.SHOW_PASSED] (state, { flag }) {
    state.showPassed = flag;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contest.js